<template>
  <div>
    <Head :title="__(title)" />

    <div class="mb-4 bg-white rounded-lg shadow border border-gray-200">
      <div class="flex flex-wrap gap-0 p-0">
        <button
          value="3"
          class="flex-1 min-w-max px-3 sm:px-5 md:px-6 py-3 sm:py-3.5 text-xs sm:text-sm md:text-sm font-medium text-gray-600 bg-white border-b-4 border-transparent transition-all duration-200 ease-out hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-0 first:rounded-l-lg"
          :class="{ 'border-b-4 border-indigo-600 text-indigo-600 bg-indigo-100 font-semibold': form.status_id === 3 }"
          @click.prevent="status_change_by_value(3)"
        >
          <span>{{ __('Pending') }} <span class="hidden sm:inline">({{ getStatusCount(3) }})</span></span>
        </button>
        <button
          class="flex-1 min-w-max px-3 sm:px-5 md:px-6 py-3 sm:py-3.5 text-xs sm:text-sm md:text-sm font-medium text-gray-600 bg-white border-b-4 border-transparent transition-all duration-200 ease-out hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-0"
          :class="{ 'border-b-4 border-indigo-600 text-indigo-600 bg-indigo-100 font-semibold': form.status_id === 4 }"
          @click.prevent="status_change_by_value(4)"
        >
          <span>{{ __('Processing') }} <span class="hidden sm:inline">({{ getStatusCount(4) }})</span></span>
        </button>
        <button
          class="flex-1 min-w-max px-3 sm:px-5 md:px-6 py-3 sm:py-3.5 text-xs sm:text-sm md:text-sm font-medium text-gray-600 bg-white border-b-4 border-transparent transition-all duration-200 ease-out hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-0"
          :class="{ 'border-b-4 border-indigo-600 text-indigo-600 bg-indigo-100 font-semibold': form.status_id === 5 }"
          @click.prevent="status_change_by_value(5)"
        >
          <span>{{ __('Completed') }} <span class="hidden sm:inline">({{ getStatusCount(5) }})</span></span>
        </button>
        <button
          class="flex-1 min-w-max px-3 sm:px-5 md:px-6 py-3 sm:py-3.5 text-xs sm:text-sm md:text-sm font-medium text-gray-600 bg-white border-b-4 border-transparent transition-all duration-200 ease-out hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-0"
          :class="{ 'border-b-4 border-indigo-600 text-indigo-600 bg-indigo-100 font-semibold': form.status_id === 6 }"
          @click.prevent="status_change_by_value(6)"
        >
          <span>{{ __('Completed AA') }} <span class="hidden sm:inline">({{ getStatusCount(6) }})</span></span>
        </button>
        <button
          class="flex-1 min-w-max px-3 sm:px-5 md:px-6 py-3 sm:py-3.5 text-xs sm:text-sm md:text-sm font-medium text-gray-600 bg-white border-b-4 border-transparent transition-all duration-200 ease-out hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-0"
          :class="{ 'border-b-4 border-indigo-600 text-indigo-600 bg-indigo-100 font-semibold': form.status_id === 7 }"
          @click.prevent="status_change_by_value(7)"
        >
          <span>{{ __('Completed UA') }} <span class="hidden sm:inline">({{ getStatusCount(7) }})</span></span>
        </button>
        <button
          class="flex-1 min-w-max px-3 sm:px-5 md:px-6 py-3 sm:py-3.5 text-xs sm:text-sm md:text-sm font-medium text-gray-600 bg-white border-b-4 border-transparent transition-all duration-200 ease-out hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-0 last:rounded-r-lg"
          :class="{ 'border-b-4 border-indigo-600 text-indigo-600 bg-indigo-100 font-semibold': form.status_id === 8 }"
          @click.prevent="status_change_by_value(8)"
        >
          <span>{{ __('Expired') }} <span class="hidden sm:inline">({{ getStatusCount(8) }})</span></span>
        </button>
      </div>
    </div>

    <div class="flex flex-col items-center justify-between gap-3 mt-4 mb-4 md:flex-row ticket-filters">
      <div class="flex-1">
        <search-input v-model="form.email" placeholder="Search by Email ID..." class="max-w-md search" @input="onFormInput" @reset="reset" />
      </div>
      <div class="flex-1">
        <search-input v-model="form.name" placeholder="Search by Name..." class="max-w-md search" @input="onFormInput" @reset="reset" />
      </div>
      <div class="flex items-center justify-center flex-1 filter-add-new">
        <Link class="btn-indigo" :href="route('tickets.create')">
          <span>{{ __('New Ticket') }}</span>
        </Link>
      </div>
    </div>


    <div class="flex flex-col items-center w-full gap-3 mb-4 md:flex-row ticket-filters">
      <div class="w-full mr-2">Filter Ticket By:</div>


      <select-input
        v-if="!(hidden_fields && hidden_fields.includes('department'))" v-model="form.department_id" class="w-full mr-2"
        @input="onFormInput"
      >
        <option :value="null">{{ __('Department') }}</option>

        <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>

      <select-input v-model="form.priority_id" class="w-full mr-2 " @input="onFormInput">
        <option :value="null">{{ __('Priority') }}</option> 

        <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>



      <select-input-filter
      
        v-if="!(hidden_fields && hidden_fields.includes('assigned_to')) && user_access.ticket.update"
        v-model="form.assigned_to" :placeholder="__('Assign To')" :on-input="doFilter" :items="assignees" class="w-full "
        @input="onFormInput" @focus="doFilter"
      />
    </div>

    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="min-w-full whitespace-nowrap ticket_list">
        <thead>
          <tr class="font-bold text-left">
            <th v-for="(h, i) in headers" :key="i">
              <span :class="{ 'sort': h.sort, 'active': form.field === h.name }">
                {{ __(h.name) }}
  
                <span v-if="h.sort" class="icons">
                  <icon
                    class="fill-gray-300"
                    :class="{ 'fill-gray-800': (form.direction === 'desc' && form.field === h.value) }" 
                    name="up" 
                    @click="sort(h.value)"
                  />
                    
                  <icon
                    class="fill-gray-300"
                    :class="{ 'fill-gray-800': (form.direction === 'asc' && form.field === h.value) }" 
                    name="down" 
                    @click="sort(h.value)"
                  />
                </span>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ticket in tickets.data" :key="ticket.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="route('tickets.edit', ticket.uid || ticket.id)"
              >
                <!-- {{ __('error') === 'error' ? moment(ticket.created_at).fromNow() : moment(ticket.created_at).locale('zh-tw').fromNow() }} -->
                {{ moment(ticket.created_at).format('MMMM Do YYYY, h:mm a') }}
              </Link>
            </td>
  
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="route('tickets.edit', ticket.uid || ticket.id)"
              >
                {{ ticket.email }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="route('tickets.edit', ticket.uid || ticket.id)"
              >
                {{ ticket.user }}
              </Link>
            </td>
            <td class="border-t">
              <span class="flex flex-col s__details">
                <span class="subject_t">{{ truncatedSubject(ticket.subject) }}</span>
                <span class="flex items-center pt-1 text-xs user__d">
                  <span v-if="ticket.assigned_to" class="flex items-center pr-4 user__n">
                    <icon name="user" class="flex-shrink-0 h-3 pr-1 fill-gray-400" />
                    {{ ticket.assigned_to }}
                  </span>
                  <span class="flex items-center user__c">
                    <icon name="folder" class="flex-shrink-0 h-3 pr-1 fill-gray-400" />
                    {{ ticket.category }}
                  </span>
                </span>
              </span>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="route('tickets.edit', ticket.uid || ticket.id)"
              >
                {{ ticket.priority }}
              </Link>
            </td>
  
  
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="route('tickets.edit', ticket.uid || ticket.id)"
              >
                {{ ticket.assigned_to }}
              </Link>
            </td>
          </tr>
          <tr v-if="tickets.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="9">{{ __('No ticket found.') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination class="mt-4" :links="tickets.links" />
  </div>
</template>

<script>
import {
  Link,
  Head,
} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SelectInput from '@/Shared/SelectInput'
import SearchInput from '@/Shared/SearchInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import moment from 'moment'

export default {
  metaInfo: {
    title: 'Tickets',
  },
  components: {
    SearchInput,
    Icon,
    Link,
    Head,
    Pagination,
    SelectInputFilter,
    SelectInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    tickets: Object,
    assignees: Array,
    auth: Object,
    title: String,
    priorities: Array,
    statuses: Array,
    types: Array,
    status_counts: Object,
    categories: Array,
    departments: Array,
    hidden_fields: Object,
  },
  remember: 'form',
  data() {
    return {

      headers:
        [
          {
            name: 'Date',
            value: 'created_at',
            sort: true,
          },
          {
            name: 'Email ID',
            value: 'email',
            sort: true,
          },
          {
            name: 'Student',
            value: 'student',
            sort: true,
          },
          {
            name: 'Subject',
            value: 'subject',
            sort: true,
          },
          {
            name: 'Priority',
            value: 'priority_id',
            sort: true,
          },

          {
            name: 'Assigned To',
            value: 'updated_at',
            sort: true,
          },
        ],
      user_access: this.$page.props.auth.user.access,
      formInteracted: false,
      form: {        
        customer_id: this.filters.customer_id,
        field: this.filters.field,
        direction: this.filters.direction,
        priority_id: this.filters.priority_id ?? null,
        status_id: this.filters.status_id ?? 3,
        type_id: this.filters.type_id ?? null,
        name: this.filters.name ?? null,
        category_id: this.filters.category_id ?? null,
        department_id: this.filters.department_id ?? null,
        email:this.filters.email ?? null,
      },
    }
  },
  watch: {
    
    form: {
    deep: true,
    handler: throttle(function () {
      if (this.formInteracted) {
        this.$inertia.get(this.route('tickets'), pickBy(this.form), {
          replace: true,
          preserveState: true,
        })
      }
    }, 150),
  },
  },
  mounted(){
    // this.status_change_by_value(3);
  },
  created() {
   
    this.moment = moment
  },
  methods: {
    onFormInput() {      
    this.formInteracted = true
  },
    truncatedSubject(subject) {
      return subject.length > 20 ? subject.slice(0, 20) + '...' : subject
    },
    doFilter(e) {
      this.axios.get(this.route('filter.assignees', {
        search: e.target.value,
      })).then((res) => {
        this.assignees.splice(0, this.assignees.length, ...res.data)
      })
    },
    sort(field) {

      this.form.field = field
      this.form.direction = this.form.direction === 'asc' ? 'desc' : 'asc'
    },
    reset() {
      this.formInteracted = false 
      this.form = mapValues(this.form, () => null)
    },
    status_change_by_value(num) {
      this.formInteracted = true
      this.form.status_id = num
    },
    getStatusCount(statusId) {
    const found = this.status_counts.find(s => s.status_id === statusId)
    return found ? found.total : 0
  },

  },
}
</script>
